/**
 * Global Message Banner
 * Watches GlobalAlert for messages and displays them.
 */

import React, { useContext } from "react";

import {
  Alert,
  Box,
  INLINE_ALERT_VARIANT_MAP,
} from "@catchoftheday/cg-components";
import { GlobalAlertContext } from "@catchoftheday/common-vendors";
import { useTheme } from "@catchoftheday/theme";

export function GlobalAlertBanner() {
  const globalAlertMap = useContext(GlobalAlertContext);
  const appTheme = useTheme();
  const maxWidth = appTheme.maxWidths.cotdWebsite ?? appTheme.maxWidths.default; // For some reason cotdWebsite isn't always set.

  if (!globalAlertMap) return null; // No context, nothing to do.

  return (
    <>
      {Array.from(globalAlertMap.entries()).map(([id, { props, children }]) => {
        const theme = props.theme ?? "light";
        const variant = props.variant ?? "default";
        const backgroundColor =
          INLINE_ALERT_VARIANT_MAP[variant].theme[theme].backgroundColor;

        return (
          <Box id={id} key={id} backgroundColor={backgroundColor}>
            <Box maxWidth={maxWidth} margin="auto" px={2}>
              <Alert {...props} type="inline">
                {children}
              </Alert>
            </Box>
          </Box>
        );
      })}
    </>
  );
}
